import { render, staticRenderFns } from "./FormStoreShippingComponent.vue?vue&type=template&id=5c6e3b7a&scoped=true"
import script from "./FormStoreShippingComponent.vue?vue&type=script&lang=js"
export * from "./FormStoreShippingComponent.vue?vue&type=script&lang=js"
import style0 from "./FormStoreShippingComponent.vue?vue&type=style&index=0&id=5c6e3b7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6e3b7a",
  null
  
)

export default component.exports